<div class="row no-gutters d-md-none" [class.bg-light]="bgLight">

  <div class="col text-truncate">
    <app-button text="{{'COLLAPSE'|translate}}" btnStyle="link" hideText="true" size="small"
      [icon]="collapsed ? 'plus' : 'minus'" (click)="toggleCollapsed()"></app-button>
    <span>{{getRowCaption(item)}}</span>
  </div>

  <!-- collapsed item row: warning and error icon-->
  <div class="col-auto float-left" *ngIf="useReservationMode === true">
    <app-tooltip-button *ngIf="!item.isRessourceAvailable" btnClass="text-danger px-2 py-1" [text]="item.warning"
      icon="x" size="default" placement="left">
    </app-tooltip-button>
    <app-tooltip-button *ngIf="item.isRessourceAvailable && !item.isBookingAllowed" btnClass="text-warning px-2 py-1"
      [text]="item.warning" icon="warning" size="default" placement="left">
    </app-tooltip-button>
  </div>
</div>

<div class="row pl-4 mt-1" *ngIf="!collapsed && useReservationMode === true">

  <!-- reserve button -->
  <div class="col">

    <Button *ngIf="item.isRessourceAvailable && item.isBookingAllowed" (click)="onRequestCreateReservation(item)"
      class="btn btn-info btn-small py-1 px-2">{{item.actionLabel|translate}}</Button>

  </div>

  <!-- info and calendar buttons -->
  <div class="text-right col-auto my-1">

    <!-- warning icon -->
    <app-tooltip-button *ngIf="!item.isRessourceAvailable" btnClass="text-danger px-2 py-1" [text]="item.warning"
      icon="x" size="default" placement="left" size="small">
    </app-tooltip-button>
    <app-tooltip-button *ngIf="item.isRessourceAvailable && !item.isBookingAllowed" btnClass="text-warning px-2 py-1"
      [text]="item.warning" icon="warning" size="default" placement="left" size="small">
    </app-tooltip-button>

    <!-- room-info -->
    <app-button *ngIf="!hideInfoButton" (click)="onOpenRoomInfo()" btnStyle="info" size="small" icon="info"
      [text]="openResourceInfoText" hideText="true" class="px-1" guestClass="room-allocation-info-button">
    </app-button>
    <!-- calendar icon -->
    <app-button *ngIf="!hideCalendarButton" (click)="onOpenSchedule(item)" btnStyle="info" size="small" icon="calendar"
      [text]="openResourceCalendarText" hideText="true" guestClass="room-allocation-calendar-button">
    </app-button>

  </div>

</div>

<app-collapsible-schedule [scheduleItems]="item.scheduleItems" [startHour]="displayTimeSpanStart"
  [endHour]="displayTimeSpanEnd" [collapsed]="collapsed" [type]="type"
  (createReservation)="onCreateReservation($event)">
  <div class="text-center">
    <div *ngFor="let subColumn of getSubColumns(item.additionalColumsData)">
      {{subColumn.captionLocaleKey|translate}}:
      {{subColumn.fieldValue}}
    </div>
  </div>
</app-collapsible-schedule>